import { Flex } from "antd";
import { Button } from "@libertify/ui";

export type CreatorDnaModalFooterProps = Readonly<{
  closeLabel: string;
  actionLabel: string;
  onClose: () => void;
  onAction?: () => void;
  actionDisabled?: boolean;
  actionLoading?: boolean;
}>;

export const CreatorDnaModalFooter = ({
  closeLabel,
  actionLabel,
  onClose,
  onAction,
  actionDisabled,
  actionLoading,
}: CreatorDnaModalFooterProps) => (
  <Flex justify="end" gap={12}>
    <Button variant="outlined" onClick={onClose}>
      {closeLabel}
    </Button>
    <Button
      variant="primary"
      onClick={onAction}
      disabled={actionDisabled}
      loading={actionLoading}
    >
      {actionLabel}
    </Button>
  </Flex>
);
